import { z } from "zod";

/**
 * Edit-member payload. Only `role` (account_type) and `monitoring`
 * (enable_monitoring) are writable via `PATCH /user/{uuid}`. SSO is
 * backend-controlled (read-only), so it is not part of the form.
 */
export const editMemberSchema = z.object({
  role: z.string().min(1),
  monitoring: z.boolean(),
});

export type EditMemberValues = z.infer<typeof editMemberSchema>;
